// Where a pop-up menu goes: at the tap, clamped inside what the camera shows (`ox`, `oy` = its scroll).
// Pure, so node tests cover it; ui/ContextMenu.js uses it.
export function menuCentre(x, y, w, h, { ox = 0, oy = 0, vw, vh }) {
  return {
    x: Math.min(Math.max(x, ox + w / 2 + 4), ox + vw - w / 2 - 4),
    y: Math.min(Math.max(y, oy + h / 2 + 4), oy + vh - h / 2 - 4),
  };
}
